module.exports = __webpack_public_path__ + "static/media/landingPage_General.860b4959.md";